import { create } from 'zustand';
import { api } from '../api/client';

interface AccountLite { id: string; name: string; phone: string; roles: string[] }

interface AuthState {
  account: AccountLite | null;
  step: 'idle' | 'authed';
  login: (phone: string, password: string) => Promise<void>;
  logout: () => void;
}

export const useAuth = create<AuthState>((set) => ({
  account: JSON.parse(localStorage.getItem('admin_account') ?? 'null') as AccountLite | null,
  step: localStorage.getItem('admin_access_token') ? 'authed' : 'idle',

  async login(phone, password) {
    const r = await api.adminPasswordLogin(phone, password);
    localStorage.setItem('admin_access_token', r.accessToken);
    localStorage.setItem('admin_refresh_token', r.refreshToken);
    localStorage.setItem('admin_account', JSON.stringify(r.account));
    set({ account: r.account as AccountLite, step: 'authed' });
  },

  logout() {
    localStorage.removeItem('admin_access_token');
    localStorage.removeItem('admin_refresh_token');
    localStorage.removeItem('admin_account');
    set({ account: null, step: 'idle' });
  },
}));
